import { Button, Modal } from "semantic-ui-react";

interface IProps {
    openModal: boolean;
    setOpenModal: (open: boolean) => void;
    handleDeleteReport: (id: string) => void;
    reportId: string;
}
export const DeleteReportModal = ({
    openModal,
    setOpenModal,
    handleDeleteReport,
    reportId,
}: IProps) => {
    return (
        <Modal open={openModal}>
            <Modal.Header>Are you sure you want to delete this report?</Modal.Header>
            <Modal.Content>
                Deleting the report will delete all of the chapters and paragraphs in it.
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={() => setOpenModal(false)}>Cancel</Button>
                <Button
                    onClick={() => {
                        handleDeleteReport(reportId);
                    }}
                >
                    Delete
                </Button>
            </Modal.Actions>
        </Modal>
    );
};
